export default __webpack_public_path__ + "static/media/class1.44b1523f.png";